var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEssentiaGroupWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.01,
    height: 146.328,
    viewBox: "0 0 145.01 146.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_essentia_group",
    "data-name": "logo essentia group",
    transform: "translate(-170.062 -213.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M171.632,248.356v-33.81h-1.559v37.493h0v37.493h1.559V248.356Z",
    transform: "translate(143.439 -1.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M315.072,329.851V296.637h-145V333.47h0V370.3h145V329.851Z",
    transform: "translate(0 -10.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M313.567,248.18V216.547H172.073v35.08h0v35.08H313.567V248.18Z",
    transform: "translate(-0.248 -1.826)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M313.567,330.272V298.638H172.073v35.08h0V368.8H313.567V330.272Z",
    transform: "translate(-0.248 -11.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(190.311 308.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M193.176,336.322V322.295H203.1v2.566h-6.94v3.048h6.793v2.566h-6.793v3.26h6.94v2.587Z",
    transform: "translate(-193.176 -322.085)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M209.13,332.044a6.151,6.151,0,0,0,4.459,1.892c1.64,0,2.439-.778,2.439-1.577,0-1.051-1.219-1.409-2.839-1.788-2.292-.526-5.236-1.156-5.236-4.29,0-2.334,2.018-4.227,5.32-4.227a7.8,7.8,0,0,1,5.468,1.956l-1.662,2.186a5.983,5.983,0,0,0-4.016-1.535c-1.346,0-2.06.589-2.06,1.43,0,.946,1.177,1.241,2.8,1.62,2.314.526,5.258,1.219,5.258,4.332,0,2.565-1.83,4.5-5.615,4.5a8.079,8.079,0,0,1-5.951-2.229Z",
    transform: "translate(-194.951 -322.055)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M224.713,332.044a6.152,6.152,0,0,0,4.459,1.892c1.64,0,2.439-.778,2.439-1.577,0-1.051-1.219-1.409-2.839-1.788-2.292-.526-5.236-1.156-5.236-4.29,0-2.334,2.018-4.227,5.32-4.227a7.8,7.8,0,0,1,5.468,1.956l-1.662,2.186a5.983,5.983,0,0,0-4.016-1.535c-1.346,0-2.06.589-2.06,1.43,0,.946,1.177,1.241,2.8,1.62,2.313.526,5.257,1.219,5.257,4.332,0,2.565-1.83,4.5-5.614,4.5a8.079,8.079,0,0,1-5.952-2.229Z",
    transform: "translate(-197.045 -322.055)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M239.907,336.322V322.295h9.926v2.566h-6.94v3.048h6.793v2.566h-6.793v3.26h6.94v2.587Z",
    transform: "translate(-199.219 -322.085)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M265.532,336.322l-6.686-9.421v9.421h-2.987V322.295h3.07l6.5,9.084v-9.084h2.986v14.027Z",
    transform: "translate(-201.291 -322.085)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M277.8,336.322v-11.4h-4.1v-2.629h11.188v2.629H280.8v11.4Z",
    transform: "translate(-203.595 -322.085)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M289.96,336.322V322.295h2.986v14.027Z",
    transform: "translate(-205.755 -322.085)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M307.831,336.322l-.883-2.419h-6.266l-.884,2.419h-3.281l5.426-14.027h3.743l5.4,14.027Zm-4.016-11.44-2.334,6.435h4.647Z",
    transform: "translate(-206.568 -322.085)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(26.718 19.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M228.847,344.553a4.262,4.262,0,0,1,3.765,1.991l-1.609.872a2.584,2.584,0,0,0-2.156-1.145,2.99,2.99,0,0,0,0,5.973,3.078,3.078,0,0,0,1.965-.695v-1.106h-2.428v-1.664h4.337v3.478a5.048,5.048,0,0,1-3.874,1.719,4.714,4.714,0,1,1,0-9.425Z",
    transform: "translate(-224.006 -344.553)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M242.108,353.821l-1.787-3.26H238.9v3.26h-1.937v-9.1h4.255a2.833,2.833,0,0,1,3.055,2.933,2.61,2.61,0,0,1-1.991,2.7l2.045,3.464Zm-1.174-7.433H238.9V348.9h2.031a1.259,1.259,0,1,0,0-2.509Z",
    transform: "translate(-225.613 -344.574)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M252.475,344.553a4.706,4.706,0,1,1-4.745,4.705A4.571,4.571,0,0,1,252.475,344.553Zm0,1.719a3,3,0,1,0,2.77,2.986A2.75,2.75,0,0,0,252.475,346.272Z",
    transform: "translate(-226.948 -344.553)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M261.393,344.724h1.963v5.4a2.1,2.1,0,1,0,4.2,0v-5.4h1.963v5.456c0,2.264-1.3,3.805-4.05,3.805-2.783,0-4.078-1.555-4.078-3.791Z",
    transform: "translate(-228.642 -344.574)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M273.979,353.821v-9.1h4.254a2.922,2.922,0,1,1,0,5.838h-2.317v3.26Zm4-7.433h-2.059V348.9h2.059a1.257,1.257,0,1,0,0-2.509Z",
    transform: "translate(-230.203 -344.574)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M257.1,242.649l-4.767,4.767,2.381,2.38-1.192,1.192-1.191-1.192h0l-1.191-1.191-2.384,2.384-1.192-1.192,2.386-2.386v0h0l-3.574-3.573h0L242.8,247.41h0l0,0,2.384,2.384-1.189,1.189-3.575-3.575,5.488-5.488h7.151l-3.1,3.1,1.192,1.192,4.3-4.3h0l1.685-1.685h0v0l-1.076,0h-10.84l0,0-7.178,7.178,1.191,1.192,0,0,3.576,3.576,1.191,1.191,1.192-1.191h0l1.189-1.189,1.191,1.191-1.191,1.192h0l-1.192,1.191,2.384,2.384-1.191,1.191-2.387-2.386v0h0l-3.574,3.573,1.191,1.192,1.195,1.195h0l1.192,1.191,2.384-2.384,1.189,1.189-3.576,3.576-5.488-5.488v-7.151l3.1,3.1,1.191-1.191-4.3-4.3v0l-1.685-1.685v0l0,0,0,1.072v10.844h0l0,0,7.179,7.178,1.191-1.191,0,0,4.767-4.767-2.381-2.38,1.192-1.192,1.191,1.192h0l1.191,1.191,2.384-2.384,1.192,1.192-2.386,2.386v0h0l3.574,3.574h0l2.386-2.387,1.189-1.189,0,0-2.384-2.384,1.189-1.189,3.575,3.575-5.488,5.488H249.22l3.1-3.1-1.192-1.192-4.3,4.3h0l-1.685,1.685h0l0,0,1.077,0h10.84l0,0,7.178-7.178-1.191-1.192,0,0-3.576-3.576h0l-1.191-1.191-1.192,1.191h0l-1.189,1.189-1.191-1.191,1.191-1.191h0l1.192-1.192-2.384-2.384,1.191-1.191,2.387,2.386v0h0l3.574-3.573h0l-1.191-1.192-1.195-1.195-1.189-1.189,0,0-2.384,2.384-1.189-1.189,3.576-3.576,5.488,5.489v7.151l-3.1-3.1-1.191,1.191,4.3,4.3v0l1.685,1.685V248.634h0l0,0-7.179-7.178-1.191,1.192Zm-11.921,4.764,1.195-1.195,1.192,1.192-1.195,1.195Zm-1.191,13.109-1.195-1.195,1.191-1.191,1.195,1.195Zm13.109,1.192-1.195,1.195-1.192-1.192,1.195-1.195Zm-5.959-10.726,1.192,1.191-1.192,1.192-1.191-1.192Zm-3.575,3.575,1.192-1.191,1.191,1.191-1.191,1.192Zm3.575,3.575-1.191-1.191,1.191-1.191,1.192,1.191Zm3.576-3.575-1.192,1.192-1.191-1.192,1.191-1.191Zm3.575-5.959,1.195,1.195-1.191,1.191L257.1,249.8Z",
    transform: "translate(-8.564 -3.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M257.99,236.39H243.33l-10.367,10.367v14.661l10.367,10.367h14.66l10.367-10.367V246.757Zm8.681,24.329-9.379,9.379H244.028l-9.379-9.379V247.455l9.379-9.379h13.264l9.379,9.379Z",
    transform: "translate(-8.087 -2.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    "data-name": "Caminho 736",
    d: "M171.656,248.69V214.546h-1.583V252.41h0v37.864h1.583V248.69Z",
    transform: "translate(-0.01 -1.329)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEssentiaGroupWhite);
export default __webpack_public_path__ + "static/media/logo-essentia-group-white.68ad179572793cc1bf158c0740b04a2f.svg";
export { ForwardRef as ReactComponent };